/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export default function InitCanny() {
  const l = () => {
    if (!document.getElementById('canny-jssdk')) {
      const f: any = document.getElementsByTagName('script')[0];
      const e: any = document.createElement('script');
      e.type = 'text/javascript';
      e.async = !0;
      e.src = 'https://canny.io/sdk.js';
      f.parentNode.insertBefore(e, f);
    }
  };

  if ('function' != typeof window.Canny) {
    const c: any = function (...args: any[]) {
      c.q.push(args);
    };

    c.q = [];
    window.Canny = c;

    'complete' === document.readyState ? l() : window.addEventListener('load', l, !1);
  }
}
